import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = null }) => {
  const { isAuthenticated, loading, userType, user } = useAuth();

  // SECURITY: Block rendering until auth state is resolved
  // This prevents unauthorized content flash before redirect
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e0e0e0',
          borderTop: '4px solid #A855DC',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '16px'
        }}></div>
        <div>Verifying authentication...</div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // SECURITY: Check authentication - redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // SECURITY: Check role-based access if allowedRoles is specified
  if (allowedRoles && !allowedRoles.includes(userType)) {
    // Special case: Owners and Managers can access employee routes (they are also employees)
    const isOwnerOrManager = user?.role === 1 || user?.role === 2;
    const isEmployeeRoute = allowedRoles.includes('employee');

    if (isOwnerOrManager && isEmployeeRoute) {
      // Allow owners/managers to access their personal employee pages
      return children;
    }

    // Redirect to unified dashboard (will show correct dashboard based on user type)
    return <Navigate to="/dashboard" replace />;
  }

  // Auth verified - render protected content
  return children;
};

export default ProtectedRoute;